import { render } from "./Cooperation.vue?vue&type=template&id=143a953a&scoped=true"
const script = {}

import "./Cooperation.vue?vue&type=style&index=0&id=143a953a&lang=scss&scoped=true"

import exportComponent from "/var/www/html/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143a953a"]])

export default __exports__